import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section id="bonos" className="defer-paint w-full scroll-mt-6 bg-zinc-900 py-12 sm:py-14" aria-labelledby="bonuses-heading" data-id="element-12" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-5xl px-6" data-id="element-13" data-mp="qta0e4or5ral">
        <SectionHeading eyebrow="Inclusi gratis" title={<span id="bonuses-heading" data-id="element-15" data-mp="14sj2y1k1cmw3">+ 5 bonus esclusivi</span>} lead="Strumenti pratici per risolvere situazioni reali in palestra." data-id="element-14" data-mp="qsi1okzuzdg3" />

        {/* Due per riga e una sola riga di beneficio per bonus: la sezione
            resta corta e il peso visivo va sulle copertine. */}
        <ul className="mt-9 grid grid-cols-2 gap-3 sm:gap-4" data-id="element-16" data-mp="19k15gu1pivj6">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col gap-3 rounded-2xl border border-zinc-800 bg-zinc-950 p-3.5 sm:flex-row sm:items-center sm:gap-5 sm:p-5" data-id="element-17" data-mp="1njan7y5k9xp9">
              <img src={bonus.image} alt={bonus.alt} className="h-auto w-16 shrink-0 self-start rounded-lg object-cover sm:w-24 sm:self-center sm:rounded-xl" width={1024} height={1024} sizes="96px" loading="lazy" decoding="async" {...{
            fetchpriority: 'low'
          }} data-id="element-18" data-mp="3prn53ys4db3b" />

              <div className="min-w-0 flex-1" data-id="element-19" data-mp="cjjsfm62y3bj">
                <div className="flex items-center gap-2.5" data-id="element-20" data-mp="gkvittws2sks">
                  <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-stone-400" data-id="element-21" data-mp="gjan40yq93lc">
                    Bonus {bonus.number}
                  </p>
                  <span className="shrink-0 rounded-full bg-yellow-500 px-2 py-0.5 font-sans text-[9px] font-bold uppercase tracking-[0.14em] text-zinc-950" data-id="element-22" data-mp="qaousw0u19pk">
                    Gratis
                  </span>
                </div>

                <h3 className="mt-2 font-serif text-lg font-bold leading-snug text-stone-100 sm:text-xl" data-id="element-23" data-mp="10707vo88y3l2">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 font-sans text-[0.8rem] leading-relaxed text-stone-400" data-id="element-24" data-mp="5nguq3cbk99l">
                  {bonus.tagline}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}